import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]

  toggle(event) {
    const item = event.currentTarget.closest("[data-accordion-target='item']")
    if (!item) return

    const wasOpen = item.classList.contains("is-open")
    this.itemTargets.forEach((el) => el.classList.remove("is-open"))
    if (!wasOpen) item.classList.add("is-open")
  }
}
